/* Learning Center Page */
export const learningCenterCatId:any = 15;
export const learningCenterAlias:string = 'learning-center-tips';

/* Legal Page */
export const legalCatId:any = 13;
export const legalAlias:string = 'legal';

/* Faq Page */
export const faqCatId:any = 14;
export const faqAlias:string = 'faq';

/* Press Center */
export const pressCenterId:any = 16;
export const pressCenterAlias:string = 'press-release';